import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import isEmpty from 'lodash/isEmpty'

import {
  Block,
  Container,
  Content,
  UserContainer,
  UserDescription,
  UserName,
  UserPhoto,
  UserPosition,
  UserSubtitle,
  VerticalSplitter,
} from './styles'

class Authors extends PureComponent {
  get authorInfo() {
    const { post } = this.props
    return post !== undefined
      ? {
          subtitle: 'Article by:',
          name: post.author,
          photo: post.authorAvatar,
          position: post.authortitle !== undefined ? post.authortitle : <br />,
          description: post.authorBio,
        }
      : {}
  }

  get ideaownerInfo() {
    const { post } = this.props
    return post !== undefined
      ? {
          subtitle: 'Idea by:',
          name: post.ideaowner,
          photo: post.ideaOwnerAvatar,
          position:
            post.ideaownertitle !== undefined ? post.ideaownertitle : <br />,
          description: post.ideaOwnerBio,
        }
      : {}
  }

  renderUser = (user, single) =>
    !isEmpty(user.name) && (
      <UserContainer single={single ? 1 : 0}>
        <UserPhoto alt={user.name} hide={single ? 0 : 1} src={user.photo} />
        <Block single={single ? 1 : 0}>
          <UserSubtitle>{user.subtitle}</UserSubtitle>
          <UserPhoto alt={user.name} hide={single ? 1 : 0} src={user.photo} />
          <UserName>{user.name}</UserName>
          <UserPosition>{user.position}</UserPosition>
          <UserDescription
            dangerouslySetInnerHTML={{ __html: user.description }}
            single={single ? 1 : 0}
          />
        </Block>
      </UserContainer>
    )

  render() {
    const author = this.authorInfo
    const ideaowner = this.ideaownerInfo
    const single =
      (!isEmpty(author.name) && isEmpty(ideaowner.name)) ||
      (isEmpty(author.name) && !isEmpty(ideaowner.name))

    return (
      <Container>
        <Content>
          {this.renderUser(author, single)}
          {!single && <VerticalSplitter />}
          {this.renderUser(ideaowner, single)}
        </Content>
      </Container>
    )
  }
}

Authors.propTypes = {
  post: PropTypes.object.isRequired,
}

export default Authors
